import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./components/home.vue"
import Registration from "./components/Registration"
import Info_center from "./components/Info_center"
import About_us from "./components/Activity/About_us.vue"
import Service from "./components/InfoCenter/services.vue"
import NotFound from "./view/page_not_found.vue"
import Gallary from "./components/Activity/gallary.vue"
import Events from "./components/Activity/events.vue"
import Event_view from "./components/Activity/event_view.vue"
import Become_volunteer from "./components/Activity/become_volunteer.vue"
import Donate from "./components/Activity/donate.vue"
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/registration',
        name: 'Registration',
        component: Registration
    },
    {
        path: '/info_center',
        name: 'Info_center',
        component: Info_center
    },
    {
        path: '/about-us',
        name: 'About_us',
        component: About_us
    },
    {
        path: '/services',
        name: 'Service',
        component: Service
    },
    {
        path: '/gallary',
        name: 'Gallary',
        component: Gallary
    },
    {
        path: '/events',
        name: 'Events',
        component: Events
    },
    {
        path: '/event_view',
        name: 'Event_view',
        component: Event_view
    },
    {
      path: '/become-volunteer',
      name: 'Become_volunteer',
      component: Become_volunteer
    },
    {
        path: '/donate',
        name: 'Donate',
        component: Donate
      },
    {
        path: '/*',
        name: 'NotFound',
        component: NotFound
    },

]
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
       document.getElementById('apps').scrollIntoView();
    }
  });
  export default router;